module.exports = __webpack_public_path__ + "static/img/gywm.20626e34.png";